import { cn } from '@/lib/utils';

export type LiveCommentsSizePreset = 'xs' | 'sm' | 'md' | 'lg';

type PanelLayoutOptions = {
  isMobile: boolean;
  isDesktop: boolean;
  size: LiveCommentsSizePreset;
};

const MOBILE_HEIGHT: Record<LiveCommentsSizePreset, string> = {
  xs: 'h-[min(18rem,44dvh)]',
  sm: 'h-[min(22rem,52dvh)]',
  md: 'h-[min(26rem,60dvh)]',
  lg: 'h-[min(30rem,68dvh)]',
};

const DESKTOP_WIDTH: Record<LiveCommentsSizePreset, string> = {
  xs: 'w-[min(16rem,calc(100vw-0.5rem))]',
  sm: 'w-[min(20rem,calc(100vw-0.5rem))]',
  md: 'w-[min(28rem,calc(100vw-0.75rem))]',
  lg: 'w-[min(38rem,calc(100vw-1rem))]',
};

const DESKTOP_HEIGHT: Record<'xs' | 'sm', string> = {
  xs: 'h-[min(20rem,58vh)]',
  sm: 'h-[min(24rem,64vh)]',
};

export function isCompactPanelSize(_size: LiveCommentsSizePreset): boolean {
  return true;
}

export function isDensePanelSize(size: LiveCommentsSizePreset): boolean {
  return size === 'xs' || size === 'sm';
}

export function getLiveCommentsPanelClassName({
  isMobile,
  isDesktop,
  size,
}: PanelLayoutOptions): string {
  if (isMobile) {
    return cn(
      'left-1 right-1 bottom-1 w-auto max-w-none',
      MOBILE_HEIGHT[size],
    );
  }

  let height: string;
  if (size === 'xs' || size === 'sm') {
    height = DESKTOP_HEIGHT[size];
  } else if (size === 'md') {
    height = isDesktop
      ? 'h-[min(calc(100vh-5.5rem),36rem)]'
      : 'h-[min(calc(100vh-6rem),32rem)]';
  } else {
    height = isDesktop
      ? 'h-[min(calc(100vh-5rem),48rem)]'
      : 'h-[min(calc(100vh-5.5rem),40rem)]';
  }

  return cn(
    'right-1 bottom-1 max-w-[calc(100vw-0.5rem)] sm:right-2 sm:bottom-2',
    DESKTOP_WIDTH[size],
    height,
  );
}

export const SIZE_CYCLE: LiveCommentsSizePreset[] = ['xs', 'sm', 'md', 'lg'];

export function nextPanelSize(current: LiveCommentsSizePreset): LiveCommentsSizePreset {
  const index = SIZE_CYCLE.indexOf(current);
  return SIZE_CYCLE[(index + 1) % SIZE_CYCLE.length];
}
